import type { IconProps } from '.';

/**
 * Chevron Right Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ChevronRightIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2929 12L8.64648 6.35356L9.35359 5.64645L15.7071 12L9.35359 18.3536L8.64648 17.6465L14.2929 12Z"
      fill="white"
    />
  </svg>
);

export default ChevronRightIcon;
